import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";
import { ReactiveFormsModule } from '@angular/forms';
import { MessagesViewComponent } from './messages.component';

@NgModule({
  declarations: [MessagesViewComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    // berichten van de server zijn vertaalcodes, geen kant-en-klare tekst
    TranslateModule
  ],
  exports: [MessagesViewComponent]
})
export class MessagesModule { }
